module.exports = __webpack_public_path__ + "static/media/Buzzer.b45ece1f.mp3";